import { computed } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { tagName } from "@ember-decorators/component";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import SelectedChoiceComponent from "select-kit/components/selected-choice";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const SelectedChoiceCategory = dt7948.c(class SelectedChoiceCategory extends SelectedChoiceComponent {
  extraClass = "selected-choice-category";
  get badge() {
    return htmlSafe(categoryBadgeHTML(this.item, {
      allowUncategorized: true,
      link: false
    }));
  }
  static {
    dt7948.n(this.prototype, "badge", [computed("item")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <SelectedChoiceComponent @item={{this.item}} @selectKit={{this.selectKit}} @extraClass={{this.extraClass}}>\n      {{this.badge}}\n    </SelectedChoiceComponent>\n  ", {
      strictMode: true,
      scope: () => ({
        SelectedChoiceComponent
      })
    }), this);
  }
}, [tagName("")]);
export default SelectedChoiceCategory;